export default __webpack_public_path__ + "static/media/centro_andes_1.3216a5f3.JPG";